import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PillButton } from "@/components/primitives";

export default function NotFound() {
  return (
    <div className="glow-black jmh-page flex items-center justify-center text-center jmh-page-center">
      <Seo title="Page Not Found" description="The page you are looking for could not be found." />
      <div>
        <h1 className="font-display gold-text text-6xl">404</h1>
        <p className="mt-4 text-[var(--bone)]/80 font-display uppercase tracking-wide2 text-sm">This page could not be found.</p>
        <div className="mt-10"><PillButton to="/" testid="notfound-home">Return Home</PillButton></div>
      </div>
    </div>
  );
}
